module.exports = __webpack_public_path__ + "img/banner-17.98218f66.jpg";